"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var FieldTypes = _interopRequireWildcard(require("../../utilities/constants/fieldTypes"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // These are the only field types we respect isRequired for


var REQUIRED_FIELD_TYPES = [FieldTypes.TXT, FieldTypes.RDO, FieldTypes.CMB, FieldTypes.CHK, FieldTypes.SIGNATURE, FieldTypes.INITIAL_SIGNATURE, FieldTypes.UNVALIDATED_SIGNATURE, FieldTypes.UNVALIDATED_INITIAL_SIGNATURE, FieldTypes.DATE, FieldTypes.DATE_SIGNED, FieldTypes.NUMBER];
var SIGNATURE_FIELD_TYPES = [FieldTypes.SIGNATURE, FieldTypes.INITIAL_SIGNATURE, FieldTypes.UNVALIDATED_SIGNATURE, FieldTypes.UNVALIDATED_INITIAL_SIGNATURE];
var INITIAL_SIGNATURE_FIELD_TYPES = [FieldTypes.INITIAL_SIGNATURE, FieldTypes.UNVALIDATED_INITIAL_SIGNATURE];
var VALIDATED_SIGNATURE_FIELD_TYPES = [FieldTypes.INITIAL_SIGNATURE, FieldTypes.SIGNATURE];

var frontendFieldIsRequired = function frontendFieldIsRequired(field) {
  var isRequired = field.isRequired,
      isDisabled = field.isDisabled; // Field cannot be required if the user can not interact

  if (isDisabled) return false; // Check if the field type sent is not present in our required field types
  // All other field types cannot be required

  var fieldType = getFrontendFieldType(field);
  if (!REQUIRED_FIELD_TYPES.includes(fieldType)) return false; // Lastly defer to the key isRequired

  return isRequired;
};

var getFrontendFieldType = function getFrontendFieldType(_ref) {
  var fieldType = _ref.fieldType,
      textType = _ref.textType,
      validateSignature = _ref.validateSignature;
  var textTypeUpper = (textType || '').toUpperCase();
  if (textTypeUpper === 'STRING') return FieldTypes.TXT;
  if (textTypeUpper === 'DATE_SIGNED') return FieldTypes.DATE_SIGNED;

  if (textTypeUpper === 'SIGNATURE' || textTypeUpper === 'INITIAL_SIGNATURE') {
    var prefixedTextType = (validateSignature === false ? 'UNVALIDATED_' : '') + textTypeUpper;
    return FieldTypes[prefixedTextType];
  }

  if (textTypeUpper && FieldTypes[textTypeUpper]) return FieldTypes[textTypeUpper];
  return FieldTypes[fieldType];
};

var getSignatureTypeInfo = function getSignatureTypeInfo(field) {
  var fieldType = getFrontendFieldType(field);
  var isSignature = !!SIGNATURE_FIELD_TYPES.includes(fieldType);
  var isInitials = INITIAL_SIGNATURE_FIELD_TYPES.includes(fieldType);
  var isValidated = VALIDATED_SIGNATURE_FIELD_TYPES.includes(fieldType);
  return {
    isInitials: isInitials,
    isSignature: isSignature,
    isValidated: isValidated
  };
};

var getSystemFieldValue = function getSystemFieldValue(field) {
  var _derived = field._derived,
      externalName = field.externalName,
      value = field.value;

  var _ref2 = _derived || {},
      _ref2$externalNameVal = _ref2.externalNameValue,
      externalNameValue = _ref2$externalNameVal === void 0 ? null : _ref2$externalNameVal;

  if (externalNameValue != null) return externalNameValue;
  return !!externalName && value;
}; // Adds initial `_derived` object to a field before rules are run on it.


var addFieldInfo = function addFieldInfo(field) {
  return _objectSpread({}, field, {
    _derived: _objectSpread({}, getSignatureTypeInfo(field), {
      isDisabled: field.isDisabled,
      isRequired: frontendFieldIsRequired(field),
      fieldType: getFrontendFieldType(field),
      externalNameValue: getSystemFieldValue(field),
      readOnlyTooltip: ''
    })
  });
};

var _default = addFieldInfo;
exports.default = _default;